import { useContext } from "react";

import { useMe } from "@/app/session/me";
import { SessionContext, type SessionUser } from "@/app/session/SessionProvider";

export function useSession() {
  const context = useContext(SessionContext);
  if (context === null) {
    throw new Error("useSession must be used inside SessionProvider");
  }
  return context;
}

/**
 * The signed-in person as the server last described them (GET /auth/me), falling back to the
 * session's copy while that loads. Undefined when nobody is signed in.
 */
export function useSessionUser(): SessionUser | undefined {
  const { state } = useSession();
  const signedIn = state.status === "signed-in";
  const me = useMe(signedIn);
  if (!signedIn) return undefined;
  return me.data ?? state.user;
}

/** The signed-in user. Only call below RequireSession. */
export function useCurrentUser(): SessionUser {
  const user = useSessionUser();
  if (user === undefined) {
    throw new Error("useCurrentUser called without a signed-in session");
  }
  return user;
}
